/**
 * 
 */
export default [
    {
        text    : 'n° de orden',
        width   : '5%',
        value   : 'id',
    },
    {
        text    : 'n° de factura',
        width   : '5%',
        value   : ({ invoice_number }) => invoice_number ? invoice_number : '-',
    },
    {
        text    : 'proveedor',
        value   : ({ pch_provider }) => pch_provider.business_name,
    },
    {
        text    : 'Creado',
        align   : 'center',
        value   : ({ created_at }) => created_at ? created_at.substr( 0, 10 ).split( '-' ).reverse().join( '-' ) : '-',
    },
    {
        text    : 'Autorizado',
        align   : 'center',
        value   : ({ authorization_date }) => authorization_date ? authorization_date.substr( 0, 10 ).split( '-' ).reverse().join( '-' ) : '-',
    },
    {
        text    : 'Estado',
        align   : 'center',
        value   : ({ pch_purchase_order_state }) => pch_purchase_order_state.state,
    },
    {
        text    : 'neto',
        align   : 'center',
        format  : 'currency',
        value   : 'net_subtotal',
    },
    {
        text    : 'iva',
        align   : 'center',
        format  : 'currency',
        value   : 'iva',
    },
    {
        text    : 'total',
        align   : 'center',
        format  : 'currency',
        value   : 'total',
    },
]
